import { render } from "./SpecialDishesSection.vue?vue&type=template&id=73d82dd6&scoped=true"
import script from "./SpecialDishesSection.vue?vue&type=script&lang=js"
export * from "./SpecialDishesSection.vue?vue&type=script&lang=js"

import "./SpecialDishesSection.vue?vue&type=style&index=0&id=73d82dd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d82dd6"]])

export default __exports__